import { h } from 'preact';

const Chevron = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 512" role="img" {...props}>
			<path d="M192 0l31 24L48 256l175 232-31 24L0 256z" />
		</svg>
	);

};

export default Chevron;
